import React, { useState, useEffect } from 'react';
import './Pagination.css';

const Pagination = ({ totalPages, onPageChange }) => {
  
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    // Reset to first page when totalPages changes
    setCurrentPage(1);
  }, [totalPages]);

  const handlePageChange = (page) => {
    console.log("page", page);
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    onPageChange(page);
  };

  const createPagination = () => {
    let liTags = [];
    let beforePage = Math.max(1, currentPage - 1);
    let afterPage = Math.min(currentPage + 1, totalPages);

    if (currentPage > 1) {
      liTags.push(
        <li key="prev" className="btn prev" onClick={() => handlePageChange(currentPage - 1)}>
          <span><i className="fas fa-angle-left"></i> Prev</span>
        </li>
      );
    } else {
      liTags.push(
        <li key="prev" className="btn prev disabled">
          <span><i className="fas fa-angle-left"></i> Prev</span>
        </li>
      );
    }
    if (currentPage > 2) {
      liTags.push(
        <li key={1} className="first numb" onClick={() => handlePageChange(1)}>
          <span>1</span>
        </li>
      );
      if (currentPage > 3) {
        liTags.push(
          <li key="dots1" className="dots">
            <span>...</span>
          </li>
        );
      }
    }

    for (let page = beforePage; page <= afterPage; page++) {
      liTags.push(
        <li key={page} className={`numb ${currentPage === page ? 'active' : ''}`} onClick={() => handlePageChange(page)}>
          <span>{page}</span>
        </li>
      );
    }

    if (currentPage < totalPages - 1) {
      if (currentPage < totalPages - 2) {
        liTags.push(
          <li key="dots2" className="dots">
            <span>...</span>
          </li>
        );
      }
      liTags.push(
        <li key={totalPages} className="last numb" onClick={() => handlePageChange(totalPages)}>
          <span>{totalPages}</span>
        </li>
      );
    }

    if (currentPage < totalPages) {
      liTags.push(
        <li key="next" className="btn next" onClick={() => handlePageChange(currentPage + 1)}>
          <span>Next <i className="fas fa-angle-right"></i></span>
        </li>
      );
    } else {
      liTags.push(
        <li key="next" className="btn next disabled">
          <span>Next <i className="fas fa-angle-right"></i></span>
        </li>
      );
    }

    return liTags;
  };

  return (
    <div className="pagination">
      <ul className='mb-0'>
        {createPagination()}
      </ul>
    </div>
  );
};

export default Pagination;
